import apiClient from './apiClient';

export default {
  loadMe: () => apiClient.get('/Account/getMe'),
  passwordChange: ({ userId, password }) => apiClient.post('/Account/password/change', { userId, password }),
};
